import React from "react"

import ItemModelV2 from "../../../../../../model2/item2/item-model"
import TasksView_Column from "../../../../../../model2/column/column"
import FieldProto from "../../../../../proto/field-proto"
import {ItemModelV2_CalculatedValues} from "../../../../../../model2/item2/calculated/@type"
import FieldFormula from "../../../formula"

type Props = {
    style?          : any

    listItem        : ItemModelV2
    column          : TasksView_Column
    field           : FieldProto

    onMouseEnter    : callback
    onMouseLeave    : callback
}

// const debug = "FieldFormula_TableCellCalculated_NotHovered"
const debug = false

export default function FieldFormula_TableCellCalculated_NotHovered(props: Props) {

    const showSummaryView   = props.listItem.view.isCollapsed
    let notHoveredContent   = null
    let aggregateIcon

    const calculatedValues: ItemModelV2_CalculatedValues | undefined = props.listItem.calculated.dataByAggregateFunction[props.field.fieldId as keyof {}]?.[props.column.aggregateFunction!]
    const ownValue = calculatedValues?.own || props.field.getViewValue(props.listItem.item)

    debug && console.log(debug, "renderNotHovered", showSummaryView, calculatedValues)

    if (showSummaryView && !!calculatedValues?.total.value && calculatedValues.total.value != calculatedValues.own) {
        notHoveredContent = props.field.getDisplayValue(calculatedValues.total.value)
        aggregateIcon = <div className={Classes("ui5-ico-12 m-r-5 m-t-1", props.column.aggregator?.icon)}/>
    } else if (ownValue > 0) {
        notHoveredContent = props.field.getDisplayValue(ownValue)
    }

    let currencyMark
    const field: FieldFormula = props.field as FieldFormula
    switch (field.formatType) {
        case 'currency':
            currencyMark = gd.const.currency[field.symbolId!]?.symbol || null
            break
    }

    return (
        <div className      = "cell-flex ui5-field-editable size-small ui5-txt-less-important-small"
             style          = {props.style}
             onMouseEnter   = {props.onMouseEnter}
             onMouseLeave   = {props.onMouseLeave}>
            {!!notHoveredContent &&
                <>
                    {aggregateIcon}

                    {currencyMark} {notHoveredContent}
                </>}
        </div>
    )
}
